import { ReactNode } from 'react';

import { NotificationOffer, NotificationSource } from '../api/codegen.api';

export enum ENotificationTypes {
	SOURCE_REJECTED = 'source-rejected',
	SOURCE_DISCONNECTED = 'connection-stopped',
	SOURCE_JOINED = 'source-joined',
	SOURCE_RECIEVED = 'application-received',
	CAP_ASSIGNED = 'cap-assigned',
	LINK_UPDATED = 'mmp-link-updated',
	CUSTOM = 'custom',
}

export interface ICustomNotification {
	title: string;
	body: string;
}

export interface IExtra {
	rejection_comment?: string;
	mmp_link?: string;
	cap?: number;
	en?: ICustomNotification;
}

export type TExtra = (keyof IExtra | '')[];
export type TExtraValue = (string | undefined)[];

export interface INotificationType {
	text: (offer: NotificationOffer, source: NotificationSource, extra?: TExtraValue) => ReactNode;
	title: (offer: NotificationOffer, source: NotificationSource) => ReactNode;
	extra: TExtra;
}
